import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const drag_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path fill="none" stroke={iconColor} d="M20,7.5002 L4,7.5002 M20,15.4997 L4,15.4997 M20,11.4997 L4,11.4997" />
    </svg>
  );
};
